import { render, staticRenderFns } from "./tools.vue?vue&type=template&id=54bd67ba&scoped=true"
import script from "./tools.vue?vue&type=script&lang=js"
export * from "./tools.vue?vue&type=script&lang=js"
import style0 from "./tools.vue?vue&type=style&index=0&id=54bd67ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bd67ba",
  null
  
)

export default component.exports